
<template>
<v-card flat color="#f5f5f5">
    <v-container fluid :class="{ 'px-0': $vuetify.breakpoint.smAndDown, 'pt-3': true}">
        <v-row class="mb-2" no-gutters>
            <v-col cols="12" md="5" class="px-2 py-1">
                <v-card class="elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">Name</div>
                    <v-text-field v-model="item.name_real" placeholder="Name" :rules="rules.name_real" class="im-select ma-0" solo flat clearable hide-details />

                </v-card>
            </v-col>
            <v-col cols="12" md="5" class="px-2 py-1">
                <v-card class="elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">Region</div>
                    <v-text-field v-model="item.region_real" placeholder="Region" class="im-select ma-0" single-line solo flat clearable hide-details />
                </v-card>
            </v-col>
            <v-col cols="12" md="2" class="px-2 py-1">
                <v-card class="elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">Country</div>
                    <v-autocomplete class="im-select pa-0 ma-0" flat solo v-model="item.country" placeholder="Country" :items="config.countries" item-text="name" item-value="code" required clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}"
                        hide-details />
                </v-card>
            </v-col>
            <v-col cols="12" class="px-2 py-1">
                <v-card class="elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">Search text</div>
                    <v-textarea v-model="item.search_text" placeholder="Search text" auto-grow class="ma-0" :rows="2" solo flat clearable hide-details />
                </v-card>
            </v-col>
            <v-col cols="12" class="px-2 py-1">
                <v-card class="elevation-1 pa-2" height="250">
                    <div class="detail font-weight-bold pa-2">Marker position</div>
                    <GmapMap :center="item.geometry.location" :zoom="11" map-type-id="terrain" style="width: auto; height: 200px;" class="mx-2">
                        <GmapMarker v-model="item.geometry.location" :position="item.geometry.location" :clickable="true" :draggable="true" @dragend="getMarkerPosition($event.latLng)" />
                    </GmapMap>
                </v-card>
            </v-col>
            <v-col cols="12" class="px-2 py-1">
                <v-card class="elevation-1" height="250">
                    <div class="detail font-weight-bold pa-2">Viewport location</div>
                    <GmapMap :center="item.geometry.location" :zoom="10" map-type-id="terrain" style="width: auto; height: 200px;" class="mx-2">
                        <GmapRectangle :bounds="viewport" :clickable="true" :editable="true" :draggable="true" @bounds_changed="updateBounds($event)" />
                    </GmapMap>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" class="px-2 py-1">
                <v-card class="elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">Timezone</div>
                    <v-autocomplete class="im-select pa-0 ma-0" flat solo v-model="item.timezone" placeholder="Timezone" :items="config.timezones" item-text="name" item-value="code" required clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}"
                        hide-details />
                </v-card>
            </v-col>
            <v-col cols="6" md="3" class="px-2 py-1">
                <v-card class="elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">Priority</div>
                    <v-text-field v-model="item.priority" placeholder="Priority" :rules="rules.priority" class="im-select ma-0" solo flat clearable hide-details />
                </v-card>
            </v-col>
            <v-col cols="6" md="3" class="px-2  py-1">
                <v-card class="mb-3 elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">Type</div>
                    <v-select class="im-select pa-0 ma-0" flat solo v-model="item.type" placeholder="Type" :items="config.place_types" item-text="name" item-value="code" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}"
                        hide-details />
                </v-card>
            </v-col>

            <v-col cols="12" md="6" class="px-2  py-1">
                <v-card class="mb-3 elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">Parents <span v-if="check_parent" class="red--text">* need parent</span></div>
                    <v-row no-gutters>
                        <v-chip v-for="(item, index) in item.parents" :key="'parent_' + index" close small @input="deleteParent(index)">
                            {{item.name_real}}
                        </v-chip>
                    </v-row>
                    <v-row no-gutters>
                        <im-place-search :class="{'error-rules': check_parent, 'im-select': true, 'pa-0': true, 'ma-0': true}" placeholder="Type to search" @input="setParent($event)" ref="parent">
                        </im-place-search>
                        <v-icon :class="{'red--text': check_parent}" @click="addParent">add_circle_outline</v-icon>
                    </v-row>
                </v-card>
            </v-col>

            <v-col cols="12" md="6" class="px-2  py-1">
                <v-card class="mb-3 elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">Children</div>
                    <v-row no-gutters>
                        <v-chip v-for="(item, index) in item.children" :key="'child' + index" close small @input="deleteChild(index)">
                            {{item.name_real}}
                        </v-chip>
                    </v-row>
                    <v-row no-gutters>
                        <im-place-search class="im-select pa-0 ma-0" placeholder="Type to search" @input="setChild($event)" ref="child">
                        </im-place-search>
                        <v-icon @click="addChild()">add_circle_outline</v-icon>
                    </v-row>
                </v-card>
            </v-col>

        </v-row>
    </v-container>
    <slot name="actions"></slot>
</v-card>
</template>

<script>
import {
    mapActions
} from "vuex";
import defaults from "../../utils/PropDefaults.js";
import IMPlaceSearch from "../../utils/IMPlaceSearch";
export default {
    components: {
        "im-place-search": IMPlaceSearch,
    },
    props: {
        item: {
            type: Object,
            default: function () {
                return this.$clone(defaults.place_item)
            }
        },
        config: {
            type: Object,
            default () {
                return {
                    place_types: [],
                    timezones: [],
                    languages: [],
                    countries: [],
                    currencies: []
                }
            }
        },

    },

    data() {
        return {
            parent: {},
            child: {},
            check_parent: false,
            //item model
            place: this.$clone(defaults.place_item),
            // set default location and viewport to Bucharest
            //item model
            place_location: {
                lat: 44.439663,
                lng: 26.096306
            },
            center_position: {
                lat: 44.439663,
                lng: 26.096306
            },
            viewport_location: {
                north: 44.541407,
                south: 44.3342445,
                east: 26.225574999999935,
                west: 25.963700099999983
            },

            // set default location and viewport to Bucharest
            geometry: {
                location: {
                    lat: 44.439663,
                    lng: 26.096306
                },
                viewport: {
                    northeast: {
                        lat: 44.541407,
                        lng: 26.225574999999935
                    },
                    southwest: {
                        lat: 44.3342445,
                        lng: 25.963700099999983
                    }
                }
            },

            //props
            items: [],
            delete_place: {},

            //validation
            valid: true,
            rules: {
                name_real: [v => !!v || "Place name is required"],
                country: [
                  v => !!v || "Place country is required",
                  v => /^.{2,2}$/.test(v) || "Place country must have 2 characters."
                ],
                priority: [
                  v => !!v || "Place priority is required",
                  v => /^[0-9]+$/.test(v) || "Place priority must be a number"
                ]
            },
            errors: []
        };
    },
    computed: {
        viewport() {
            return {
                north: parseFloat(this.item.geometry.viewport.northeast.lat),
                south: parseFloat(this.item.geometry.viewport.southwest.lat),
                east: parseFloat(this.item.geometry.viewport.northeast.lng),
                west: parseFloat(this.item.geometry.viewport.southwest.lng)
            }
        },
    },

    watch: {
        item: {
            handler() {
                this.$refs.child.reset();
                this.$refs.parent.reset();
            }
        }
    },

    methods: {

        ...mapActions("alert", ["success", "error"]),

        deleteParent(key) {
            this.item.parents.splice(key, 1);
        },

        deleteChild(key) {
            this.item.children.splice(key, 1);
        },

        setParent(value) {
            this.parent = value;
        },

        setChild(value) {
            this.child = value;
        },

        addParent() {
            this.item.parents.push({
                id: this.parent.id,
                name_real: this.parent.name
            });
            this.$refs.parent.reset();
        },

        addChild() {
            this.item.children.push({
                id: this.child.id,
                name_real: this.child.name
            });
            this.$refs.child.reset();
        },

        getMarkerPosition(LatLng) {
            this.item.geometry.location = {
                lat: LatLng.lat(),
                lng: LatLng.lng()
            };
        },

        updateBounds(bounds) {
            this.item.geometry.viewport.northeast.lat = bounds.pa.h;
            this.item.geometry.viewport.northeast.lng = bounds.ka.h;
            this.item.geometry.viewport.southwest.lat = bounds.pa.g;
            this.item.geometry.viewport.southwest.lng = bounds.ka.g;
        },

    }
};
</script>
